import { Component, OnInit } from '@angular/core';
import { Meta } from '../common/seo.service';
import { FillerService } from '../common/Service_tnFiller';
import { SiteConfigurationService } from '../common/site-configuration.service'; 

import { TnGoogleMap } from '../components/tngooglemap/tngooglemap.component';

@Component({
	selector: 'app-about',
	templateUrl: '../themes/default/html/about.component.html',
	styleUrls: ['../themes/default/css/about.component.scss']
})
export class AboutComponent implements OnInit {

	infoAbout: any = "";
	GeoAddress: any = ""; 
	_mySettings: any;

	constructor(private myMeta: Meta, private filler: FillerService, private mySettings: SiteConfigurationService) {

		this._mySettings = mySettings.getFullConfig();

		new Promise((resolve, reject) => {
		this.filler.Get_About().subscribe(
			data => {
				this.infoAbout = Object.assign([], data)
				resolve(true);
			}, err => { console.log(err) }
			);
		}).then(
		e => myMeta.setTitle(this.infoAbout.Title)
		);


  }

	ngOnInit() {
		this.GenerateGeoAddress();
	}

	GenerateGeoAddress() {
		var tmpTitle = "";

		try
		{
		tmpTitle = this._mySettings.e400.geo.label;//  JSON.parse(this._mySettings.e400.geo).label;
		} catch (e) {
		tmpTitle = "";
		}

		tmpTitle += ' ' + this._mySettings.e400.geo.address.aa3 + ' (' + this._mySettings.e400.geo.address.aa2 + ')'; // AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U
		
		this.GeoAddress = '' + tmpTitle;
		this.putInHTML(this.GeoAddress);

		console.log(this.GeoAddress);
	}

	putInHTML(p) {

		var s;
		try {
			s = document.getElementById("googleMap");
		} catch (e) {
			return;
		}
		
		//let compFactory = this.cfr.resolveComponentFactory(TnGoogleMap);
		// s.InnerHTML = 'questo è un test';
		// s.value = 'ciao';

		var destinationURL = "https://www.google.com/maps/embed/v1/place?key=";
		var destinationKey = "AIzaSyBviSL2wtnnSFgDdVbgJkTlogZpCaegu4U";
		var framesrc = destinationURL + destinationKey + '&q=' + p;

		var gm = document.createElement("iframe");
		gm.width = '100%';
		gm.height="100%";
		gm.frameBorder="0";
		//gm.className = "tngooglemap";
		gm.src = framesrc;

		s.appendChild(gm);

	}

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/about/about.component.ts